import { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import NameEntry from './components/NameEntry'
import HomePage from './components/HomePage'
import Projects from './components/Projects'
import Contact from './components/Contact'
import Layout from './components/Layout'
import './App.css'

const VISITOR_TYPE_KEY = 'portfolio_visitor_type'

function App() {
  const [visitorType, setVisitorType] = useState(() => {
    return localStorage.getItem(VISITOR_TYPE_KEY)
  })

  const handleVisitorTypeSubmit = (type) => {
    setVisitorType(type)
  }

  if (!visitorType) {
    return (
      <div className="app">
        <NameEntry onVisitorTypeSubmit={handleVisitorTypeSubmit} />
      </div>
    )
  }

  return (
    <Router>
      <div className="app">
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage visitorType={visitorType} />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  )
}

export default App
